<template>
  <el-dialog
    :title="isUpdate ? '编辑渠道' : '添加渠道'"
    :visible="visible"
    width="640px"
    :destroy-on-close="true"
    :lock-scroll="false"
    custom-class="ele-dialog-form"
    append-to-body
    @update:visible="updateVisible"
    @closed="loading = false">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" @submit.native.prevent>
      <el-divider content-position="left">基础信息</el-divider>
      <el-form-item label="渠道名称:" prop="upName">
        <el-input v-model="form.upName" class="ele-block" clearable maxlength="64" show-word-limit placeholder="请输入" />
      </el-form-item>
      <el-form-item label="渠道编号:" prop="upUid">
        <el-input v-model="form.upUid" class="ele-block" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="渠道密钥:" prop="upKey">
        <el-input
          v-model="form.upKey"
          class="ele-block"
          clearable
          show-password
          placeholder="请输入" />
      </el-form-item>
      <el-form-item label="其它参数:" prop="upOther">
        <el-input v-model="form.upOther" class="ele-block" clearable placeholder="请输入" />
      </el-form-item>
      <el-divider content-position="left">接口配置</el-divider>
      <el-form-item label="基础地址:" prop="upBaseUrl">
        <el-input v-model="form.upBaseUrl" class="ele-block" clearable placeholder="请输入" />
      </el-form-item>
      <el-divider content-position="left">安全配置</el-divider>
      <el-form-item label="回调IP:" prop="upIp">
        <el-input v-model="form.upIp" class="ele-block" type="textarea" :rows="3" resize="none" placeholder="请输入" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
const defaultForm = () => ({
  id: undefined,
  status: 1,
  upName: '',
  upUid: '',
  upKey: '',
  upOther: '',
  upBaseUrl: '',
  upIp: ''
});

export default {
  name: 'UplistEdit',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      form: defaultForm(),
      loading: false,
      isUpdate: false,
      rules: {
        upName: [{ required: true, message: '请输入', trigger: 'blur' }],
        upUid: [{ required: true, message: '请输入', trigger: 'blur' }],
        upKey: [{
          validator: (rule, value, callback) => {
            if (!this.isUpdate && !value) {
              callback(new Error('请输入'));
              return;
            }
            callback();
          },
          trigger: 'blur'
        }],
        upBaseUrl: [{ required: true, message: '请输入', trigger: 'blur' }],
        upIp: [{ required: true, message: '请输入', trigger: 'blur' }]
      }
    };
  },
  watch: {
    visible(val) {
      if (val) this.initForm();
    },
    data() {
      if (this.visible) this.initForm();
    }
  },
  methods: {
    initForm() {
      const src = this.data && Object.keys(this.data).length ? this.data : null;
      this.isUpdate = !!src;
      this.form = src ? {
        id: src.id,
        status: src.status == null ? 1 : src.status,
        upName: src.upName,
        upUid: src.upUid,
        upKey: src.upKey,
        upOther: src.upOther,
        upBaseUrl: src.upBaseUrl,
        upIp: src.upIp
      } : defaultForm();
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const payload = { ...this.form };
        const key = String(payload.upKey || '').trim();
        if (this.isUpdate && (!key || key.indexOf('****') !== -1)) {
          delete payload.upKey;
        }
        this.$http.post('/Uplist/edit', payload).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg || '保存成功');
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg || '保存失败');
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>

<style scoped>
::v-deep .el-divider {
  margin: 4px 0 22px;
}
::v-deep .el-divider__text {
  font-size: 13px;
  font-weight: 500;
  color: #303133;
}
</style>
